// assetUniverse.js — SINGLE SOURCE OF TRUTH for the scannable/selectable asset universe.
// Consumed by BOTH the frontend catalog (src/assetLibrary.js re-exports this as
// ASSET_LIBRARY, imported natively by App.js) AND the CJS worker (via the gitignored
// universe.bundle.cjs artifact produced by scripts/engine-runner/bundle-universe.js,
// mirroring the engine/config/market-hours/tier-limits bundle pattern). Keeping one list
// here means the catalog and the scan universe can never drift.
//
// Crypto keyed WITH -USD, stocks keyed BARE — matching followedCoins/livePrices keys and
// getProvider's dash-pair → coinbase / bare → alpaca split. Shape: { symbol, name, type }.
export const ASSET_UNIVERSE = [
  // ---- CRYPTO (Coinbase USD pairs) ----
  { symbol: "BTC-USD", name: "Bitcoin", type: "crypto" },
  { symbol: "ETH-USD", name: "Ethereum", type: "crypto" },
  { symbol: "SOL-USD", name: "Solana", type: "crypto" },
  { symbol: "XRP-USD", name: "XRP", type: "crypto" },
  { symbol: "LTC-USD", name: "Litecoin", type: "crypto" },
  { symbol: "ADA-USD", name: "Cardano", type: "crypto" },
  { symbol: "DOGE-USD", name: "Dogecoin", type: "crypto" },
  { symbol: "DOT-USD", name: "Polkadot", type: "crypto" },
  { symbol: "LINK-USD", name: "Chainlink", type: "crypto" },
  { symbol: "AVAX-USD", name: "Avalanche", type: "crypto" },
  { symbol: "SUI-USD", name: "Sui", type: "crypto" },
  { symbol: "ONDO-USD", name: "Ondo", type: "crypto" },
  { symbol: "AAVE-USD", name: "Aave", type: "crypto" },
  { symbol: "NEAR-USD", name: "NEAR", type: "crypto" },
  { symbol: "BCH-USD", name: "Bitcoin Cash", type: "crypto" },
  { symbol: "UNI-USD", name: "Uniswap", type: "crypto" },
  { symbol: "XLM-USD", name: "Stellar", type: "crypto" },
  { symbol: "ALGO-USD", name: "Algorand", type: "crypto" },
  { symbol: "INJ-USD", name: "Injective", type: "crypto" },
  { symbol: "RENDER-USD", name: "Render", type: "crypto" },
  { symbol: "TIA-USD", name: "Celestia", type: "crypto" },
  { symbol: "CRV-USD", name: "Curve DAO", type: "crypto" },
  { symbol: "FET-USD", name: "Artificial Superintelligence", type: "crypto" },
  { symbol: "SHIB-USD", name: "Shiba Inu", type: "crypto" },
  { symbol: "BONK-USD", name: "Bonk", type: "crypto" },
  { symbol: "JTO-USD", name: "Jito", type: "crypto" },
  // ---- STOCKS (US large-caps, Alpaca-tradable) ----
  { symbol: "AAPL", name: "Apple", type: "stock" },
  { symbol: "MSFT", name: "Microsoft", type: "stock" },
  { symbol: "NVDA", name: "Nvidia", type: "stock" },
  { symbol: "GOOGL", name: "Alphabet", type: "stock" },
  { symbol: "AMZN", name: "Amazon", type: "stock" },
  { symbol: "META", name: "Meta", type: "stock" },
  { symbol: "TSLA", name: "Tesla", type: "stock" },
  { symbol: "AMD", name: "AMD", type: "stock" },
  { symbol: "NFLX", name: "Netflix", type: "stock" },
  { symbol: "JPM", name: "JPMorgan", type: "stock" },
  { symbol: "AVGO", name: "Broadcom", type: "stock" },
  { symbol: "TSM", name: "Taiwan Semiconductor", type: "stock" },
  { symbol: "ORCL", name: "Oracle", type: "stock" },
  { symbol: "LLY", name: "Eli Lilly", type: "stock" },
  { symbol: "V", name: "Visa", type: "stock" },
  { symbol: "MA", name: "Mastercard", type: "stock" },
  { symbol: "WMT", name: "Walmart", type: "stock" },
  { symbol: "XOM", name: "Exxon Mobil", type: "stock" },
  { symbol: "COST", name: "Costco", type: "stock" },
  { symbol: "JNJ", name: "Johnson & Johnson", type: "stock" },
  { symbol: "HD", name: "Home Depot", type: "stock" },
  { symbol: "PG", name: "Procter & Gamble", type: "stock" },
  { symbol: "BAC", name: "Bank of America", type: "stock" },
  { symbol: "ABBV", name: "AbbVie", type: "stock" },
  { symbol: "CRM", name: "Salesforce", type: "stock" },
  { symbol: "CVX", name: "Chevron", type: "stock" },
  { symbol: "KO", name: "Coca-Cola", type: "stock" },
  { symbol: "PEP", name: "PepsiCo", type: "stock" },
  { symbol: "ADBE", name: "Adobe", type: "stock" },
  { symbol: "MRK", name: "Merck", type: "stock" },
  { symbol: "WFC", name: "Wells Fargo", type: "stock" },
  { symbol: "COIN", name: "Coinbase", type: "stock" },
  { symbol: "CSCO", name: "Cisco", type: "stock" },
  { symbol: "ACN", name: "Accenture", type: "stock" },
  { symbol: "MCD", name: "McDonald's", type: "stock" },
  { symbol: "INTC", name: "Intel", type: "stock" },
  { symbol: "QCOM", name: "Qualcomm", type: "stock" },
  { symbol: "DIS", name: "Disney", type: "stock" },
  { symbol: "TXN", name: "Texas Instruments", type: "stock" },
  { symbol: "PLTR", name: "Palantir", type: "stock" },
  { symbol: "UBER", name: "Uber", type: "stock" },
  { symbol: "BA", name: "Boeing", type: "stock" },
  { symbol: "GE", name: "GE Aerospace", type: "stock" },
  { symbol: "PFE", name: "Pfizer", type: "stock" },
  { symbol: "T", name: "AT&T", type: "stock" },
  { symbol: "NKE", name: "Nike", type: "stock" },
  { symbol: "MU", name: "Micron", type: "stock" },
  { symbol: "SHOP", name: "Shopify", type: "stock" },
  { symbol: "XYZ", name: "Block", type: "stock" },
  { symbol: "SPCX", name: "SpaceX", type: "stock" },
  { symbol: "ABT", name: "Abbott", type: "stock" },
  { symbol: "DHR", name: "Danaher", type: "stock" },
  { symbol: "TMO", name: "Thermo Fisher", type: "stock" },
  { symbol: "BMY", name: "Bristol Myers Squibb", type: "stock" },
  { symbol: "AMGN", name: "Amgen", type: "stock" },
  { symbol: "GILD", name: "Gilead", type: "stock" },
  { symbol: "CVS", name: "CVS Health", type: "stock" },
  { symbol: "CI", name: "Cigna", type: "stock" },
  { symbol: "ELV", name: "Elevance Health", type: "stock" },
  { symbol: "ISRG", name: "Intuitive Surgical", type: "stock" },
  { symbol: "MDT", name: "Medtronic", type: "stock" },
  { symbol: "SYK", name: "Stryker", type: "stock" },
  { symbol: "BSX", name: "Boston Scientific", type: "stock" },
  { symbol: "VRTX", name: "Vertex", type: "stock" },
  { symbol: "REGN", name: "Regeneron", type: "stock" },
  { symbol: "ZTS", name: "Zoetis", type: "stock" },
  { symbol: "HCA", name: "HCA Healthcare", type: "stock" },
  { symbol: "MCK", name: "McKesson", type: "stock" },
  { symbol: "HUM", name: "Humana", type: "stock" },
  { symbol: "BDX", name: "Becton Dickinson", type: "stock" },
  { symbol: "GS", name: "Goldman Sachs", type: "stock" },
  { symbol: "MS", name: "Morgan Stanley", type: "stock" },
  { symbol: "C", name: "Citigroup", type: "stock" },
  { symbol: "SCHW", name: "Charles Schwab", type: "stock" },
  { symbol: "AXP", name: "American Express", type: "stock" },
  { symbol: "BLK", name: "BlackRock", type: "stock" },
  { symbol: "SPGI", name: "S&P Global", type: "stock" },
  { symbol: "PYPL", name: "PayPal", type: "stock" },
  { symbol: "COF", name: "Capital One", type: "stock" },
  { symbol: "USB", name: "U.S. Bancorp", type: "stock" },
  { symbol: "PNC", name: "PNC Financial", type: "stock" },
  { symbol: "TFC", name: "Truist", type: "stock" },
  { symbol: "CME", name: "CME Group", type: "stock" },
  { symbol: "ICE", name: "Intercontinental Exchange", type: "stock" },
  { symbol: "CB", name: "Chubb", type: "stock" },
  { symbol: "PGR", name: "Progressive", type: "stock" },
  { symbol: "AON", name: "Aon", type: "stock" },
  { symbol: "TRV", name: "Travelers", type: "stock" },
  { symbol: "MET", name: "MetLife", type: "stock" },
  { symbol: "ADP", name: "ADP", type: "stock" },
  { symbol: "NOW", name: "ServiceNow", type: "stock" },
  { symbol: "INTU", name: "Intuit", type: "stock" },
  { symbol: "AMAT", name: "Applied Materials", type: "stock" },
  { symbol: "LRCX", name: "Lam Research", type: "stock" },
  { symbol: "KLAC", name: "KLA", type: "stock" },
  { symbol: "ADI", name: "Analog Devices", type: "stock" },
  { symbol: "MRVL", name: "Marvell", type: "stock" },
  { symbol: "SNPS", name: "Synopsys", type: "stock" },
  { symbol: "CDNS", name: "Cadence", type: "stock" },
  { symbol: "PANW", name: "Palo Alto Networks", type: "stock" },
  { symbol: "ANET", name: "Arista Networks", type: "stock" },
  { symbol: "FTNT", name: "Fortinet", type: "stock" },
  { symbol: "CRWD", name: "CrowdStrike", type: "stock" },
  { symbol: "DDOG", name: "Datadog", type: "stock" },
  { symbol: "NET", name: "Cloudflare", type: "stock" },
  { symbol: "SNOW", name: "Snowflake", type: "stock" },
  { symbol: "IBM", name: "IBM", type: "stock" },
  { symbol: "APH", name: "Amphenol", type: "stock" },
  { symbol: "TEL", name: "TE Connectivity", type: "stock" },
  { symbol: "GLW", name: "Corning", type: "stock" },
  { symbol: "SBUX", name: "Starbucks", type: "stock" },
  { symbol: "TGT", name: "Target", type: "stock" },
  { symbol: "LOW", name: "Lowe's", type: "stock" },
  { symbol: "CMCSA", name: "Comcast", type: "stock" },
  { symbol: "TJX", name: "TJX", type: "stock" },
  { symbol: "BKNG", name: "Booking", type: "stock" },
  { symbol: "MAR", name: "Marriott", type: "stock" },
  { symbol: "CMG", name: "Chipotle", type: "stock" },
  { symbol: "ORLY", name: "O'Reilly", type: "stock" },
  { symbol: "ROST", name: "Ross Stores", type: "stock" },
  { symbol: "YUM", name: "Yum Brands", type: "stock" },
  { symbol: "LULU", name: "Lululemon", type: "stock" },
  { symbol: "ABNB", name: "Airbnb", type: "stock" },
  { symbol: "COP", name: "ConocoPhillips", type: "stock" },
  { symbol: "SLB", name: "SLB", type: "stock" },
  { symbol: "EOG", name: "EOG Resources", type: "stock" },
  { symbol: "MPC", name: "Marathon Petroleum", type: "stock" },
  { symbol: "PSX", name: "Phillips 66", type: "stock" },
  { symbol: "VLO", name: "Valero", type: "stock" },
  { symbol: "OXY", name: "Occidental", type: "stock" },
  { symbol: "KMI", name: "Kinder Morgan", type: "stock" },
  { symbol: "WMB", name: "Williams", type: "stock" },
  { symbol: "HAL", name: "Halliburton", type: "stock" },
  { symbol: "DVN", name: "Devon Energy", type: "stock" },
  { symbol: "CAT", name: "Caterpillar", type: "stock" },
  { symbol: "HON", name: "Honeywell", type: "stock" },
  { symbol: "UNP", name: "Union Pacific", type: "stock" },
  { symbol: "UPS", name: "UPS", type: "stock" },
  { symbol: "RTX", name: "RTX", type: "stock" },
  { symbol: "LMT", name: "Lockheed Martin", type: "stock" },
  { symbol: "DE", name: "Deere", type: "stock" },
  { symbol: "EMR", name: "Emerson", type: "stock" },
  { symbol: "ETN", name: "Eaton", type: "stock" },
  { symbol: "ITW", name: "Illinois Tool Works", type: "stock" },
  { symbol: "GD", name: "General Dynamics", type: "stock" },
  { symbol: "NOC", name: "Northrop Grumman", type: "stock" },
  { symbol: "CSX", name: "CSX", type: "stock" },
  { symbol: "NSC", name: "Norfolk Southern", type: "stock" },
  { symbol: "FDX", name: "FedEx", type: "stock" },
  { symbol: "PH", name: "Parker Hannifin", type: "stock" },
  { symbol: "MMM", name: "3M", type: "stock" },
  { symbol: "WM", name: "Waste Management", type: "stock" },
  { symbol: "GEV", name: "GE Vernova", type: "stock" },
  { symbol: "CTAS", name: "Cintas", type: "stock" },
  { symbol: "FAST", name: "Fastenal", type: "stock" },
  { symbol: "PAYX", name: "Paychex", type: "stock" },
  { symbol: "PCAR", name: "Paccar", type: "stock" },
  { symbol: "ROK", name: "Rockwell Automation", type: "stock" },
  { symbol: "GM", name: "General Motors", type: "stock" },
  { symbol: "F", name: "Ford", type: "stock" },
  { symbol: "LIN", name: "Linde", type: "stock" },
  { symbol: "APD", name: "Air Products", type: "stock" },
  { symbol: "SHW", name: "Sherwin-Williams", type: "stock" },
  { symbol: "ECL", name: "Ecolab", type: "stock" },
  { symbol: "FCX", name: "Freeport-McMoRan", type: "stock" },
  { symbol: "NEM", name: "Newmont", type: "stock" },
  { symbol: "NUE", name: "Nucor", type: "stock" },
  { symbol: "DOW", name: "Dow", type: "stock" },
  { symbol: "NEE", name: "NextEra Energy", type: "stock" },
  { symbol: "DUK", name: "Duke Energy", type: "stock" },
  { symbol: "SO", name: "Southern Company", type: "stock" },
  { symbol: "D", name: "Dominion", type: "stock" },
  { symbol: "AEP", name: "American Electric Power", type: "stock" },
  { symbol: "EXC", name: "Exelon", type: "stock" },
  { symbol: "SRE", name: "Sempra", type: "stock" },
  { symbol: "XEL", name: "Xcel Energy", type: "stock" },
  { symbol: "PEG", name: "Public Service Enterprise", type: "stock" },
  { symbol: "ED", name: "Consolidated Edison", type: "stock" },
  { symbol: "AMT", name: "American Tower", type: "stock" },
  { symbol: "PLD", name: "Prologis", type: "stock" },
  { symbol: "CCI", name: "Crown Castle", type: "stock" },
  { symbol: "EQIX", name: "Equinix", type: "stock" },
  { symbol: "SPG", name: "Simon Property", type: "stock" },
  { symbol: "O", name: "Realty Income", type: "stock" },
  { symbol: "PSA", name: "Public Storage", type: "stock" },
  { symbol: "DLR", name: "Digital Realty", type: "stock" },
  { symbol: "WELL", name: "Welltower", type: "stock" },
  { symbol: "VICI", name: "VICI Properties", type: "stock" },
  { symbol: "VZ", name: "Verizon", type: "stock" },
  { symbol: "TMUS", name: "T-Mobile", type: "stock" },
  { symbol: "MDLZ", name: "Mondelez", type: "stock" },
  { symbol: "CL", name: "Colgate-Palmolive", type: "stock" },
  { symbol: "KMB", name: "Kimberly-Clark", type: "stock" },
  { symbol: "GIS", name: "General Mills", type: "stock" },
  { symbol: "KHC", name: "Kraft Heinz", type: "stock" },
  { symbol: "HSY", name: "Hershey", type: "stock" },
  { symbol: "STZ", name: "Constellation Brands", type: "stock" },
  { symbol: "KDP", name: "Keurig Dr Pepper", type: "stock" },
  { symbol: "MNST", name: "Monster Beverage", type: "stock" },
  { symbol: "RSG", name: "Republic Services", type: "stock" },
];
